<template>
  <div>
    <div v-if="isShowPage" class="pb-3">
      <img width="100px" :src="page.pictureUrl" :alt="page.name" class="mr-3" /><span>{{
        page.name
      }}</span>
    </div>
    <b-button
      v-if="!connected"
      variant="primary"
      ref="bntLiveAuthLoginFacebook"
      @click="loginFacebook"
      :disabled="isDisabled"
      class="text-nowrap my-auto"
    >
      FACEBOOK PAGE
    </b-button>
    <!-- <b-button
      variant="primary"
      ref="bntLiveAuthLoginFacebookLogout"
      @click="logout"
      class="text-nowrap my-auto"
    >
      FACEBOOK PAGE Logout
    </b-button> -->

    <div v-if="connected">
      <b-form-group label="Select page">
        <b-form-radio
          v-model="selectedPage"
          v-for="(page, pageIndex) in pages"
          :key="pageIndex"
          name="some-radios"
          :value="page"
          class="m-3"
        >
          <img :src="page.picture.data.url" alt="" />{{
            page.name
          }}</b-form-radio
        >
      </b-form-group>
      <b-button @click="confirm" variant="primary">ตกลง</b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "LiveLoginFacebook",
  data() {
    return {
      appId: this.$facebookAppId,
      secret: this.$facebookSecret,
      version: "v12.0",
      profile: {},
      authorized: false,
      authResponse: null,
      connected: false,
      selectedPage: null,
      pages: [],
      isShowPage: false,
      page: null,
      getPageToken: null,
    };
  },
  props: {
    isDisabled: {
      required: false,
      type: Boolean,
    },
  },
  async created() {
    try {
      await this.checkLoginPage();
      var _this = this;
      window.fbAsyncInit = function () {
        FB.init({
          appId: _this.appId,
          cookie: true,
          xfbml: true,
          version: _this.version,
        });
        FB.getLoginStatus(({ authResponse }) => {
          console.log("getLoginStatus ", authResponse);
        });

        FB.AppEvents.logPageView(); 
      };

      (function (d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");
    } catch (error) {
      console.log("connect error ", error)
    }
  },
  methods: {
    async checkLoginPage() {
      await this.axios
        .get(`${this.$baseUrl}/livePost/checkLoginPage`)
        .then((data) => {
          console.log("check login page", data);
          if (data.result == 1) {
            this.page = data.detail;
            this.isShowPage = true;
          }
        });
    },
    async confirm() {
      console.log({
        id: 0,
        pageid: this.selectedPage.id,
        name: this.selectedPage.name,
        tokenfacebook: this.authResponse.accessToken,
        pictureUrl: this.selectedPage.picture.data.url,
      });
      await this.axios
        .post(`${this.$baseUrl}/livePost/updateFacebookPage`, {
          id: 0,
          pageid: this.selectedPage.id,
          name: this.selectedPage.name,
          tokenfacebook: this.selectedPage.access_token,
          pictureUrl: this.selectedPage.picture.data.url,
        })
        .then((data) => {
          console.log("update facebook page", data);
          if (data.detail == 1) {
            this.$router.push({ path: `/live` }).catch(() => {});
            // alert("update facebook page success");
          } else {
            alert("update facebook page fail");
          }
        });
    },
    async getPages() {
      await this.axios
        .post(`${this.$baseUrl}/livePost/facebookPage`, {
          psid: this.authResponse.userID,
          userToken: this.getPageToken,
        })
        .then((data) => {
          console.log("get pages", data);
          if (data.result == 1) {
            this.isShowPage = false;
            this.pages = data.detail;
          }
        });
    },
    getProfile: async function () {
      console.log("this auth", this.authResponse);
      let vm = this;
      await FB.api("/me?fields=name,id,email", (response) => {
        //   this.$store.commit("live/setFbProfile", response);
        //   this.$store.commit("live/setIsFbAuthenticate", true);

        console.log("get me", response);
        // console.log("storegetProfile", this.$store.state.live.fbProfile);
        FB.api(
          `/oauth/access_token?grant_type=fb_exchange_token&client_id=${vm.appId}&client_secret=${vm.secret}&fb_exchange_token=${vm.authResponse.accessToken}`,
          (res) => {
            //   this.$store.commit("live/setFbLongAuthenDetail", res);
            console.log("get profile", res);
            vm.getPageToken = res.access_token;
            console.log("get page token", vm.getPageToken);
            console.log("token", vm.authResponse.accessToken);
            vm.getPages();
          }
        );
      });
    },
    loginFacebook() {
      let vm = this;
      FB.login(
        function (response) {
          console.log("login", response);
          vm.statusChangeCallback(response);
        },
        {
          scope:
            "email, public_profile, pages_show_list, pages_read_engagement, pages_manage_metadata, pages_messaging, pages_manage_posts, pages_manage_engagement ",
            // "email, public_profile, pages_show_list, pages_read_engagement, pages_messaging, pages_manage_engagement ",
            // "public_profile,email",
          return_scopes: true,
        }
      );
    },

    logout() {
      let vm = this;
      FB.logout(function (response) {
        vm.statusChangeCallback(response);
      });
    },
    statusChangeCallback(response) {
      console.log("login", response);
      let vm = this;
      if (response.status === "connected") {
        vm.authorized = true;
        vm.authResponse = response.authResponse;
        // this.$store.commit("live/setFbAuthenDetail", response.authResponse);
        vm.authorized = response.authResponse;
        // console.log("storelogin", this.$store.state.live.fbAuthenDetail);
        vm.getProfile();
        // vm.getPages();
        vm.connected = true;
      } else if (response.status === "not_authorized") {
        vm.authorized = false;
      } else if (response.status === "unknown") {
        vm.profile = {};
        vm.authorized = false;
      } else {
        vm.authorized = false;
      }
    },
  },
};
</script>

<style rel="stylesheet" scoped></style>
